exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-400f741f] .el-card__body{height:100%}.detail-height[data-v-400f741f]{height:calc(100% - 52px)}.card-custom-height[data-v-400f741f]{height:calc(100% - 50px)}", ""]);

// exports
